import classes from './BookingSoonPossible.module.css';
import fancyClock from '../../../../assets/icons/fancy_clock.svg';

export const BookingSoonPossible = () => {
  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <img src={fancyClock} alt="location" height={48} width={48} />
      </div>
      <div className={classes.textColumn}>
        <span className={classes.headerText}>
          Im Moment keine freien Plätze – du bist aktuell auf der Warteliste!
        </span>
        <div className={classes.bodyText}>
          Vielen Dank für deine Registrierung! Leider sind aktuell alle
          Studienplätze belegt. Sobald wieder ein Platz frei wird, melden wir
          uns bei dir – anschliessend kannst du deinen Onboarding-Termin ganz
          einfach in einem unserer Center buchen.
        </div>
      </div>
    </div>
  );
};
